/**
 * @desc 图片在某一个大小范围内等比例缩放，主要解决在 safari 里 img 没法自动等比例缩放的问题
 * @author Kody
 * @date 2020/07/14
 */
import React, { useState, useCallback } from 'react';
import imageApi from '@umu/umu-image-handle';

interface IProps {
    src: string;
    alt?: string;
    maxWidth?: number;
    maxHeight?: number;
}
export const AutoImg = (props: IProps) => {
    const { alt = '', src, maxWidth, maxHeight } = props;
    const [size, setSize] = useState({ width: '100%', height: 'auto' });
    const imgRef = useCallback(
        (node) => {
            if (node) {
                const img: HTMLImageElement = new Image();
                img.src = src;
                img.onload = () => {
                    const parentWidth = (node.parentNode || node.parentElement).offsetWidth;
                    const originWidth = img.naturalWidth;
                    const originHeight = img.naturalHeight;
                    const ratio = originHeight / originWidth;
                    let computedHeight = originHeight;
                    let computedWidth = parentWidth;
                    if (maxHeight) {
                        if (originHeight > maxHeight) {
                            computedHeight = maxHeight;
                            const width = Math.round(maxHeight / ratio);
                            computedWidth = [width, maxWidth, parentWidth].sort((a, b) => a - b)[0];
                            computedHeight = Math.round(computedWidth * ratio);
                        } else {
                            computedWidth = maxWidth && parentWidth > maxWidth ? maxWidth : parentWidth;
                            computedHeight = Math.round(computedWidth * ratio);
                        }
                    } else {
                        computedHeight = Math.round(computedWidth * ratio);
                    }
                    setSize({
                        width: computedWidth + 'px',
                        height: computedHeight + 'px',
                    });
                };
            }
        },
        [maxWidth, maxHeight, src],
    );

    const render = () => {
        const style = {
            width: size.width,
            height: size.height,
            maxWidth: '100%',
        };
        const url = imageApi.process(src);
        return <img src={url} alt={alt} ref={imgRef} style={style} className="auto-img" />;
    };
    return render();
};
